import { PaymentTaskState } from "../enums/tasks";
import { IPaymentTask } from "../interfaces/delivery-company/tasks";

export const emptyPaymentTask: IPaymentTask = {
    id: "",
    status: PaymentTaskState.SCHEDULED,
    branch: null,
    driver: null,
    merchant_location: null,
    completion_method: ""
}